export const extractErrorInfo = (error: any): { reason: string; details?: string } => {
  // Handle null/undefined
  if (!error) {
    return { reason: 'Unknown error' }
  }

  // Extract from nested response object (Phoenix channel errors)
  const errorObj = error?.response || error

  // Extract reason (try multiple possible fields)
  const reason = errorObj.reason || errorObj.message || error.message || 'Connection failed'
  
  // Extract details if available
  const details = errorObj.details || error.details

  return { 
    reason, 
    ...(details && { details })
  }
}